import Swiper from './Swiper.vue';

Swiper.install = (Vue) => {
  Vue.component(Swiper.name, Swiper);
};

export default Swiper;
